var $41d49e6197917be1$exports = {};
$41d49e6197917be1$exports = {
    "Empty": `Tom`
};


export {$41d49e6197917be1$exports as default};
//# sourceMappingURL=da-DK.mjs.map
